import React, { useEffect, useState } from "react";
import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { GetLoanShortRecoveryReport } from "../../../../Helpers/APIEndPoints/EndPoints";

const ShortRecoveryReport = () => {
  return (
    <>
      <MonthlyCommonDashboard
        PageName="ShortRecoveryReport"
        ExportToExcelUrl={GetLoanShortRecoveryReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default ShortRecoveryReport;
